export default {"src":"/uk/_next/static/media/piggyBankIcon.05c78de8.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};